import { pathJoin } from 'src/reducers/routing/utils'

export const createPlanRouteMap = (prefix: string) => ({
  'checkout/:stripeQuoteId': (stripeQuoteId: string) =>
    pathJoin(prefix)('checkout')(stripeQuoteId).chain,
  'edit/:stripeQuoteId': (stripeQuoteId: string) =>
    pathJoin(prefix)('edit')(stripeQuoteId).chain,
})
